const DATA_ATTRIBUTE_TRIGGER_NAME = "data-analytics-click-id";
const DATA_ATTRIBUTE_EVENT_NAME = "data-analytics-event-name";

let navigationTriggerId: string | null = null;
let eventName: string | null | undefined = null;
export default defineNuxtPlugin(() => {
  const router = useRouter();

  // --- Global Click Listener (Client-side only) ---
  document.body.addEventListener(
    "click",
    (event) => {
      // Find the closest ancestor element (link or button) with the data attribute
      const targetElement = (event.target as Element)?.closest<HTMLElement>(
        `[${DATA_ATTRIBUTE_TRIGGER_NAME}]`,
      );

      eventName = targetElement?.getAttribute(DATA_ATTRIBUTE_EVENT_NAME);

      // Process all data-analytics-* attributes
      if (targetElement) {
        const analyticsData: Record<string, string> = {};

        const attributes = targetElement.attributes;

        // Loop through all attributes to find data-analytics-*
        for (let i = 0; i < attributes.length; i++) {
          const attr = attributes[i];
          if (
            attr.name.startsWith("data-analytics-") &&
            attr.name !== DATA_ATTRIBUTE_TRIGGER_NAME &&
            attr.name !== DATA_ATTRIBUTE_EVENT_NAME
          ) {
            // Extract the key by removing the 'data-analytics-' prefix
            const key = attr.name
              .substring("data-analytics-".length)
              .replaceAll("-", "_");

            analyticsData[key] = attr.value;
          }
        }

        navigationTriggerId = targetElement.getAttribute(
          DATA_ATTRIBUTE_TRIGGER_NAME,
        );

        if (eventName) {
          const triggerData = { trigger: navigationTriggerId };
          trackEvent(eventName, { ...triggerData, ...analyticsData });

          eventName = null;
        }
      } else {
        navigationTriggerId = null;
      }
    },
    true,
  );

  router.beforeEach(async (to, from) => {
    if (to.path === from.path) {
      return;
    }

    trackEvent("user_site_redirected", {
      trigger: navigationTriggerId,
      destination: to.path,
      page_path: from.path,
    });
  });
});
